export enum Steps {
  Bookings = 0,
  Identification= 1,
  YourVehicle = 2,
  SelectService = 3,
  SelectDealer = 4,
  EstimatedPrice = 9,
  Appointment= 5,
  CollectionAndDelivery= 10,
  ContactDetails= 6,
  ReviewAndSubmit,
}
